<template>
	<NewsTickerLayout v-if="displayStore.isDesktop && headerStore.getCountry === 'USA' && $route.name === 'home'">
		<VerticalSlider />
	</NewsTickerLayout>
	<footer
		class="BottomFooter"
		:class="
			$route.name === '404' ||
			$route.path.split('/')[1] === 'my' ||
			$route.path.split('/')[2] === 'signup-complete' ||
			$route.path.split('/')[1] === 'auth' ||
			$route.path.split('/')[1] === 'sub' ||
			(!displayStore.isDesktop && headerStore.getCountry === 'USA' && $route.name === 'home' && 'mobile_us')
		"
	>
		<div class="c_inner">
			<div class="company">
				<h2 class="company_name">대가의 선택</h2>
				<div class="company_info">
					<p>
						대가의 선택에서 제공하는 모든 정보는 투자 참고용 자료일 뿐이며, 매수나 매도를 권유하는 것이 아닙니다.<br
							class="br_none"
						/>
						대가들의 종목과 전략은 공개된 투자 아이디어를 연구·참고해 구현했으며, 특정 인물·기관의 보증이나 제휴가
						아닙니다.
						<br class="br_none" />
						최종 투자 판단과 책임은 전적으로 투자자 본인에게 있으며, 투자 결과에 따라 원금 손실이 발생할 수 있고, 그
						손실 역시 투자자 본인에게 귀속됩니다.<br class="br_none" />
						본 자료는 신뢰할 수 있다고 판단되는 데이터로 작성되었으나, 정확성과 완전성을 보장할 수 없습니다.<br
							class="br_none"
						/>
						따라서 본 자료는 투자 결과에 대한 법적 책임의 증빙자료로 사용될 수 없습니다.<br class="br_none" />
						당사는 금융감독원에 정식으로 신고된 유사투자자문업체이며, 금융감독원 홈페이지에서 확인할 수 있습니다.<br
							class="br_none"
						/>
						당사는 금융투자업자가 아닌 유사투자자문업자로서, 개별적인 투자 상담이나 자금 운용은 제공하지 않습니다.
					</p>
				</div>
			</div>
			<div class="temrms_list">
				<nav class="terms">
					<a href="http://first-partners.co.kr/" target="_blank">회사소개</a>
					<router-link to="/my/terms-service">이용약관</router-link>
					<router-link to="/my/privacy-policy">개인정보처리방침</router-link>
				</nav>
				<nav class="info_menu">
					<div class="info_list">
						<div class="info_item">
							<p>(주)퍼스트파트너스</p>
							<p>대표이사: 박상준</p>
						</div>

						<p>사업자등록번호: 362-81-02282</p>
						<p>통신판매업 신고번호: 2023-서울마포-3433</p>
						<p>first_partner@naver.com</p>
					</div>
					<div class="button_box">
						<button
							type="button"
							class="c_button primary-fill radius-full font-semi"
							@click="$router.replace('/notice-detail/126')"
						>
							<span>카카오 상담톡 문의 안내</span
							><img src="@/assets/img/common/arrow_next.svg" alt="카카오 상담톡 문의 아이콘" loading="lazy" />
						</button>
					</div>
				</nav>
				<!-- <p class="copyright">COPYRIGHT (C)HAEON Solution. All Rights Reserved.</p> -->
			</div>
		</div>
	</footer>
</template>

<script setup lang="ts">
import NewsTickerLayout from '@/components/layout/main/NewsTickerLayout.vue';
import VerticalSlider from '@/components/swiper/VerticalSlider.vue';
import { useDisplayStore } from '@/stores/display';
import { useHeaderStore } from '@/stores/header';

const headerStore = useHeaderStore();
const displayStore = useDisplayStore();
// // 카카오톡 문의하기
// const onClickKakaoInquiry = () => {
// 	let agent = navigator.userAgent.toLowerCase();
// 	if (agent.indexOf('android') !== -1) {
// 		// window.masterpick.nativeUrlOpenBrowser('https://pf.kakao.com/_kzxkIG/chat');
// 		window.location.href = 'https://pf.kakao.com/_kzxkIG/chat';
// 	} else if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) {
// 		window.webkit.messageHandlers.nativeUrlOpenBrowser.postMessage('https://pf.kakao.com/_kzxkIG/chat');
// 	} else {
// 		window.open('https://pf.kakao.com/_kzxkIG/chat');
// 	}
// };
</script>

<style scoped lang="scss">
.BottomFooter {
	background-color: var(--color-bg-mid);
	color: var(--color-font-white);
	padding: 3.2rem 0;
	@media screen and (max-width: 1280px) {
		padding-bottom: calc(var(--bottomMenu-height) + 3.2rem);
	}
	.c_inner {
		display: flex;
		flex-direction: column;
		gap: var(--space-x-large);

		.company {
			.company_name {
				font-weight: var(--font-w-semi-bold);
				font-size: var(--font-s-mid);
				line-height: normal;
				letter-spacing: 0;
				margin-bottom: var(--space-x-small);
			}
			.company_info {
				font-weight: var(--font-w-light);
				font-size: var(--font-s-small);
				display: flex;
				flex-wrap: wrap;
				line-height: normal;
				color: var(--color-base-light);
			}
		}
		.temrms_list {
			display: flex;
			flex-direction: column;
			gap: var(--space-x-small);
			.terms {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				flex-direction: row;
				position: relative;
				color: var(--color-base-white);
				font-weight: var(--font-w-semi-bold);
				font-size: var(--font-s-small);
				line-height: normal;

				:nth-child(1),
				:nth-child(2) {
					padding-right: 1.6rem;
				}
				:nth-child(2),
				:nth-child(3) {
					padding-left: 1.6rem;
				}
			}
			.terms :nth-child(1)::after,
			.terms :nth-child(2)::after {
				content: '';
				display: inline-block;
				height: 50%; /* 원하는 높이로 조절 */
				border-right: 1px solid var(--color-base-mid);
				position: absolute;
				top: 25%; /* border가 텍스트 중앙에 위치하도록 조절 */
				padding-right: 1.6rem;
			}

			.info_menu {
				display: flex;
				justify-content: space-between;
				@media screen and (max-width: 1280px) {
					flex-direction: column;
					gap: var(--space-mid);
				}
				.info_list {
					display: flex;
					align-items: center;
					gap: 0.4rem 2.4rem;
					flex-wrap: wrap;
					font-weight: var(--font-w-light);
					font-size: var(--font-s-small);
					line-height: normal;
					color: var(--color-base-light);
					.info_item {
						display: flex;
						gap: 0.4rem 2.4rem;
						@media screen and (max-width: 1280px) {
							gap: 0.8rem;
						}
					}
					@media screen and (max-width: 1280px) {
						flex-direction: column;
						align-items: flex-start;
					}
					@media screen and (max-width: 1280px) {
						gap: 0.4rem 0.8rem;
					}
					> a {
						flex-shrink: 0;
						display: block;
						border-radius: 50%;
						background-color: rgba(217, 217, 217, 0.3);
						padding: 0.6rem;
						width: 3.6rem;
						height: 3.6rem;
						img {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}

		.copyright {
			color: var(--color-font-mid);
		}
	}
	.button_box {
		width: fit-content;
		.c_button {
			font-size: var(--font-s-mid);
			line-height: 1.79rem;
		}
	}
}

.mobile_us {
	@media screen and (max-width: 1280px) {
		padding-bottom: calc(var(--bottomMenu-height) + 3.2rem + var(--vertical-slider-height));
	}
	background: #1b2433;
}
</style>
